import { Rogue } from '@/js/services/Rogue'
import type { BuyRequest } from '@/js/services/types/order'

export const ZeusBarTextColorMap:{[key: string]: string} = {
  White        : '#ffffff',
  Black        : '#333333',
  Blue         : 'rgb(55,84,139)',
  Red          : '#BA0C2F',
  'OD Green'   : 'rgb(64,63,50)',
  Pink         : 'rgb(217, 68, 133)',
  Orange       : 'rgb(187,82,47)',
  Purple       : 'rgb(83,67,110)',
  Green        : 'rgb(118,148,50)',
  'Light Blue' : 'rgb(60,114,164)',
  'Desert Tan' : 'rgb(144,129,105)',
  Gray         : '#5b5857',
  Maroon       : 'rgb(87,40,33)',
  Navy         : 'rgb(44,54,71)',
}

export const ZeusBarSwatchColorMap = Object.keys(ZeusBarTextColorMap).reduce((acc:{[key: string]: string}, key) => {
  const newKey = key.toLowerCase().replace(' ', '')
  acc[newKey] = ZeusBarTextColorMap[key]

  return acc
}, {})

// There are some invalid option combinations that we want to prevent (black sleeves + black text), and
// we also want to set Text Color to "None" if they have not entered any text, so that the price is accurate
export function validateZeusBar(buyRequest: BuyRequest, rogue: Rogue) {
  const parent = rogue.getProductById(buyRequest.productId)

  if (!parent || !buyRequest.children?.length || !parent.customOptions?.length) {
    return
  }

  const simple = rogue.getProductById(buyRequest.children[0].productId)
  const barColor = simple?.attributes.color

  if (!barColor) {
    return
  }

  const options:{[key: string] : string} = {}

  parent.customOptions.forEach(opt => {
    options[opt.title] = buyRequest.options?.[opt.id] || ''
  })

  const sleeveOpt = options['Choose Sleeve Finish']
  const collarText = parent.customOptions?.find(opt => opt.title === 'Choose Sleeve Finish')

  console.log(buyRequest, parent, options, sleeveOpt, collarText)
  //
  // if (!options.shaftText.val) {
  //   // If no shaft text is added, set the color to None to remove price
  //   opts[this.options.shaftColor.id] = this.options.shaftColor.options.None
  // } else if (this.options.shaftColor.val === 'None') {
  //   this.options.shaftColor.val = 'Black'
  // }
  //
  // if (!this.options.collarTextBottom.val && !this.options.collarTextTop.val) {
  //   opts[this.options.collarColor.id] = this.options.collarColor.options.None
  // } else if (this.options.collarColor.val === 'None') {
  //   this.options.collarColor.val = 'White'
  // }
}

export const nflRecipeMap: { [key:string]: string } = {
  'erDo2Kx-' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-ARI-1',
  JNYknK2z   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H194C-DC-ARI-2',
  DfMRE3dF   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-ARI-1',
  Ka6fS1Zj   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H194C-DC-ARI-2',
  ntvvX7mO   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-ARI',
  '7F0s0mPh' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H194C-DC-ATL-1',
  IEiEAOv3   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-ATL-2',
  '8pGsJqbM' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H194C-DC-ATL-1',
  rRCuQr9G   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-ATL-2',
  Hcu1Uk75   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-ATL',
  tPb56TGR   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-BAL-1',
  UghJoJzv   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H273C-DC-BAL-2',
  oAX0Ez5D   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H273C-DC-BAL-3',
  DPfhcDFQ   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H273C-DC-BAL-4',
  q19s4tIu   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-BAL-1',
  bYFYiKT8   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H273C-DC-BAL-2',
  FIb1aURG   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H273C-DC-BAL-3',
  WL6vI1Ie   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H273C-DC-BAL-4',
  IFQDRLcI   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-BAL',
  'Faxew-oC' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-BUF-1',
  IIqafjB2   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H287C-DC-BUF-2',
  lWBviQtx   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-BUF-1',
  jy0nJmSq   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H287C-DC-BUF-2',
  L2_Sw2EG   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-BUF',
  We4PWo_h   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H278C-DC-CAR-1',
  '06dVesEj' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-CAR-2',
  WE2NC_LB   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-CAR-3',
  MnlT3OH7   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H278C-DC-CAR-1',
  jWD0oy77   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-CAR-2',
  qozfbvAp   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-CAR-3',
  '-WoDTwDM' : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-CAR',
  _vojjPG0   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CHI-1',
  'HSut-WKo' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H5395C-DC-CHI-2',
  '8snsFH6b' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CHI-3',
  Xscz7OAm   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CHI-1',
  VNUy5zAz   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H5395C-DC-CHI-2',
  KLeBs8QL   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CHI-3',
  MEFmJyTI   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-CHI',
  Nnb1Etp_   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-CIN-1',
  '4715vCwP' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CIN-2',
  SAopUrYs   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CIN-3',
  B1wvURY_   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-CIN-1',
  _p6JHbUk   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CIN-2',
  '-SF8vfZX' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CIN-3',
  xXX_T34P   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-CIN',
  'e9p-XUBk' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H412C-DC-CLE-1',
  vwzhfMVK   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CLE-2',
  Q73FT4l5   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CLE-3',
  rVid1dYU   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CLE-4',
  '56ELa5G4' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2026C-DC-CLE-5',
  tejAMGgW   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H412C-DC-CLE-1',
  rM1VxMNO   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CLE-2',
  ae2h5NCv   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CLE-3',
  n0Bw5n5k   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CLE-4',
  '58jNGknQ' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2026C-DC-CLE-5',
  ogu6I3HP   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-CLE',
  iKMiADzn   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-DAL-1',
  'iskXu9X-' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-DAL-2',
  IoXHNvq9   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-DAL-1',
  eOwmFUUl   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-DAL-2',
  ma6GiskS   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-DAL',
  Hv4FD7ao   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-DEN-1',
  XWvQaZp_   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-DEN-2',
  n0GnqwNS   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2133-DC-DEN-3',
  'qmsThd-Q' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-DEN-1',
  'gu-Hq6TX' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-DEN-2',
  qroHR9j8   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2133-DC-DEN-3',
  k78NlKXG   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-DEN',
  KYMr8nkq   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-DET-1',
  k0V_3xTD   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H278C-DC-DET-2',
  NVztrF54   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H278C-DC-DET-3',
  rbossXjc   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-DET-1',
  BpTNmFrB   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H278C-DC-DET-2',
  piYfEJWL   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H278C-DC-DET-3',
  I86jCUI_   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-DET',
  UFRIOljH   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H343C-DC-GB-1',
  SzjmYsV4   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H343C-DC-GB-2',
  yzeJNV_Q   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H343C-DC-GB-1',
  ociVP931   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H343C-DC-GB-2',
  deHq8Nsi   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-GB',
  'sNFfY0-Y' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-HOU-1',
  nprv86UA   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-HOU-2',
  '7ZJL-f49' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-HOU-1',
  TF0Z151T   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-HOU-2',
  vnIU2LJE   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-HOU',
  tPqMUiJY   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-IND-1',
  FUXC8_fp   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2133-DC-IND-2',
  '9wapHITU' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2133-DC-IND-3',
  OhClTCED   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-IND-1',
  '0-hOOpN4' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2133-DC-IND-2',
  GceLLK3R   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2133-DC-IND-3',
  YwSngw54   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-IND',
  '-sfVEr1a' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-JAX-1',
  RDe09MWH   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H3155C-DC-JAX-2',
  h1dyiVkT   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-JAX-1',
  cXWHIQ4j   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H3155C-DC-JAX-2',
  CgQ6HAvJ   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-JAX',
  xXa5qauq   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-KC-1',
  wH3E3G9c   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H1805-DC-KC-2',
  ao9wXN23   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-KC-1',
  O7Swo9ZF   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H1805-DC-KC-2',
  'zE5yF-fd' : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-KC',
  GdRmhT1v   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-LAS-1',
  '-YrqkGLv' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-LAS-2',
  a7bI1ZSJ   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-LAS-1',
  XJ_pvQ_d   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-LAS-2',
  ZgjobDni   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-LAS',
  '1liyw1Lu' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H278C-DC-LAC-1',
  '1CKqm4ec' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-LAC-2',
  JLGMq0wO   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H278C-DC-LAC-1',
  Yz4WOyC4   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-LAC-2',
  tCIHw1ol   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-LAC',
  Y8P5iRWq   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H287C-DC-LAR-1',
  Kl86tzYn   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-LAR-2',
  tcqObKhC   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-LAR-2.1',
  'Kz-EIKS5' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H287C-DC-LAR-1',
  bBcqWytM   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-LAR-2',
  'AL-7N68c' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-LAR-2.1',
  __lYeeE1   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-LAR',
  mLa962Mm   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H3155C-DC-MIA-1',
  JWI4v3Hh   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-MIA-2',
  '2ZJvC_Ez' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-MIA-3',
  'jVTj-D5K' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H3155C-DC-MIA-1',
  zYfrB01m   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-MIA-2',
  WcAg9GHM   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-MIA-3',
  Xyyc86sU   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-MIA',
  MT6U5GlF   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-MIN-1',
  '1YX3VsiP' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2868C-DC-MIN-2',
  eyt6IyCv   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2868C-DC-MIN-3',
  'J8L7QLr-' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-MIN-1',
  _TO2nqHt   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2868C-DC-MIN-2',
  TikDhN_1   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2868C-DC-MIN-3',
  r1WmGI1I   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-MIN',
  LxnQhOXl   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-NE-1',
  '0iEm9N8C' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-NE-2',
  'KYv-Dz8e' : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-NE-3',
  '0F62R0ub' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-NE-1',
  '2zgsGmcA' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-NE-2',
  PBn6xGYB   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-NE-3',
  HyItH0A9   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-NE',
  ndK8v49o   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-NO-1',
  '8dkDt7NX' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-NO-2',
  '1xhQzULQ' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-NO-3',
  x9cdigfr   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-NO-1',
  Y8TVWbbw   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-NO-2',
  PrsabE7N   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-NO-3',
  Z9jYoIDb   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-NO',
  Ow8tnWO3   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2133-DC-NYG-1',
  huIHMefC   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H2133-DC-NYG-2',
  '3YCAe32S' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2133-DC-NYG-1',
  '7htpbTh4' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H2133-DC-NYG-2',
  jOTYgRM6   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-NYG',
  lmyvN2p2   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-NYJ-1',
  qRsV_QBl   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H343C-DC-NYJ-2',
  DlqaSahA   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-NYJ-1',
  UK3ciz9Z   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H343C-DC-NYJ-2',
  '0YotzB5H' : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-NYJ',
  cMBZJrEt   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-PHI-1',
  vvW56z19   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H316C-DC-PHI-2',
  kBf2Fip4   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H316C-DC-PHI-3',
  X9fKiMnI   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-PHI-1',
  X7UcWHVb   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H316C-DC-PHI-2',
  u3BLcpQS   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H316C-DC-PHI-3',
  zRXWOh4h   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-PHI',
  KgCwGJ4X   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-PIT-1',
  ErnKUv3Y   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-PIT-2',
  jZBx9KUS   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-PIT-1',
  CRIRcX8a   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-PIT-2',
  Y8WT0Pki   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-PIT',
  '9nELUspb' : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-SF-1',
  _kqONKpr   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-SF-2',
  pcXH8Rta   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-SF-1',
  NY56E0o0   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-SF-2',
  UThtb3Oo   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-SF',
  dgoaXagR   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H368C-DC-SEA-1',
  uBMTwvSY   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-SEA-2',
  yYEECEc4   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-SEA-3',
  bCBJWCOZ   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H368C-DC-SEA-1',
  PStQCTT0   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-SEA-2',
  Zd3KEa8z   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-SEA-3',
  J9riN_dz   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-SEA',
  '7Cz6Y8Rg' : '/rogue-bella-bar-nfl-edition?sku=RA2894-E10-DC-TB-1',
  MuPOuUzq   : '/rogue-bella-bar-nfl-edition?sku=RA2894-E10-DC-TB-2',
  AkPCLqVv   : '/rogue-bella-bar-nfl-edition?sku=RA2894-E10-DC-TB-3',
  lBfbXfOs   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-E10-DC-TB-1',
  vLTqT0wq   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-E10-DC-TB-2',
  '0w-3YtLK' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-E10-DC-TB-3',
  '-5EKjbr8' : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-TB',
  pJVTM5dy   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-TEN-1',
  nh12DkiX   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-TEN-1.1',
  wuXWMrIg   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H279C-DC-TEN-2',
  CeqF9R7V   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H279C-DC-TEN-2.1',
  JRVW3666   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-TEN-3',
  HhtwKoyX   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H655C-DC-TEN-4',
  Qs1c7gKI   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-TEN-1',
  D2ICzxRo   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-TEN-1.1',
  DkhGlEqg   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H279C-DC-TEN-2',
  vni2Foyy   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H279C-DC-TEN-2.1',
  '4Lx_h-JA' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-TEN-3',
  'Ifj-d7Ga' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H655C-DC-TEN-4',
  y1YOzkU7   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-TEN',
  O5knE9mE   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-TEN-1.1',
  uAlYg8G5   : '/rogue-bella-bar-nfl-edition?sku=RA2894-H504M-DC-WAS-1',
  NaU4dnKs   : '/rogue-bella-bar-nfl-edition?sku=RA2894-EBLACK-DC-WAS-2',
  YioHUxUW   : '/rogue-ohio-bar-nfl-edition?sku=RA2889-H504M-DC-WAS-1',
  '0OLd8xs8' : '/rogue-ohio-bar-nfl-edition?sku=RA2889-EBLACK-DC-WAS-2',
  nsk2ORMk   : '/rogue-ohio-power-bar-nfl-edition?sku=RA2895-SSDC-WAS',
}
